import { useTranslation } from '@lt/localization';
import cn from 'classnames';
import React from 'react';
import type { Tariff } from 'src/store/payment/types';
import { pluralizeMonths } from 'src/utils/pluralizeUtils';
import { formatCurrency } from 'src/utils/stringUtils';
import SubmitAgreement from '../SubmitAgreement';
import styles from './tbankCreditExpanded.module.css';

type Props = {
  tariffs: Tariff[];
  selectedTariffId?: string;
  isHotelOnly: boolean;
  setCurrentTariff: (value: string) => void;
};

const TbankCreditExpanded = (props: Props) => {
  const { tariffs, selectedTariffId, setCurrentTariff, isHotelOnly } = props;
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.tariffsContainer}>
        {tariffs.map((tariff) => (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events
          <div
            key={tariff.id}
            className={cn(styles.tariff, {
              [styles.activeTab]: selectedTariffId === tariff.id,
            })}
            onClick={() => setCurrentTariff(tariff.id)}
            role="button"
            tabIndex={0}
          >
            <div className={styles.terms}>
              <span>{formatCurrency(tariff.amount)}</span>{' '}
              <span className={styles.cross}>×</span>{' '}
              <span>{tariff.period}</span>
            </div>
            <div>
              {tariff.overpayment
                ? `${t('tbank.credit.overpayment')} ${tariff.overpayment}`
                : t('tbank.credit.noOverpayment')}
            </div>
            <div>
              {tariff.period} {pluralizeMonths(tariff.period)}
            </div>
          </div>
        ))}
      </div>

      <SubmitAgreement>
        {isHotelOnly
          ? t('checkout.payment.bookHotel')
          : t('checkout.payment.bookTour')}
      </SubmitAgreement>
    </div>
  );
};

export default TbankCreditExpanded;
